'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useMemo } from 'react';

/**
 * Returns a tooltip content for the market.
 *
 * @param localErrorMessage - The local error message.
 * @returns The tooltip content.
 */
const useMarketTooltip = localErrorMessage => {
  const $ = _c(3);
  let t0;
  bb0: {
    if (localErrorMessage) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
          wordBreak: "break-all"
        };
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      let t2;
      if ($[1] !== localErrorMessage) {
        t2 = <span className="text-3xs" style={t1}>{localErrorMessage}</span>;
        $[1] = localErrorMessage;
        $[2] = t2;
      } else {
        t2 = $[2];
      }
      t0 = t2;
      break bb0;
    }
    t0 = undefined;
  }
  return t0;
};
export default useMarketTooltip;